import app_general_en from "./app_general_en";
import app_general_ru from "./app_general_ru";
import app_general_tr from "./app_general_tr";

import portalHelp_ru from "./portalHelp/portalHelp_ru";
import portalHelp_en from "./portalHelp/portalHelp_en";
import portalHelp_tr from "./portalHelp/portalHelp_tr";

// const desktop_en = require("./pages/desktop_en.ts");
// const desktop_ru = require("./pages/desktop_ru.ts");

let lng = "en";
export default {
  _: "Client-side dictionary",
  en: {
    lng: "en", ...app_general_en, ...portalHelp_en
  },
  ru: {
    lng: "ru", ...app_general_ru, ...portalHelp_ru
  },
  tr: {
    lng: "tr", ...app_general_tr, ...portalHelp_tr
  },
  get: (req) => {
    const isClientSide = !(typeof process !== "undefined" && (process.release.name.search(/node|io.js/) !== -1));
    if (isClientSide) { return (~document.title.indexOf("[RU]") ? "ru" : (~document.title.indexOf("[TR]") ? "tr" : "en")) }
    if (req && req.session && req.session.lng) { return req.session.lng }
    return (lng || "en"); // For Server-side
  },
  set: (lngparam) => { lng = lngparam }
};
